import React from "react";
import { useState } from "react";
import DeleteAnalysis from "../../smart/buttonPopups/DeleteAnalysis";
import { Table } from "../DataTable";

const Analyses = props => {

    console.log(props.rows);
    const [checkValues, setCheckValues] = useState([]);

    const renderRow = (row, renderData) => {
    console.log(row);
        return (
            <React.Fragment>
            {renderData(row.ID, { key: "id" })}
            {renderData(row.name, { key: "name", here: "/PM/analysis/view/" + row.ID })}
            {renderData(row.taskCount != '0' ? `${row.taskID} (+${row.taskCount} tasks)` : row.taskID, { key: "taskid" })}
            {renderData(row.createdBy, { key: "createdby" })}
            {renderData(row.created, { key: "created" })}
        </React.Fragment>
        )
    }

    let titleContent = 
    <DeleteAnalysis className={checkValues.length <= 0 ? "button--disabled" : ""} analysisIDs={checkValues} projectID={props.projectID} />;

    return (
        <Table checkbox={true} newCheckValues={setCheckValues} getCheckValue={row => row.ID} title={"Analyses"} titleContent={titleContent} renderRow={renderRow} rows={props.rows} cols={[
            { name: "id", sortCol: "ID" },
            { name: "name", sortCol: "name" },
            { name: "task id", sortCol: "taskID" },
            { name: "created by", sortCol: "createdBy" },
            { name: "created", sortCol: "created" }]}
        />
    )
}

export default Analyses;